<template>
  <div class="timeline-datepicker">
    <div class="timeline-datepicker-icons is-overlay">
      <div class="icon is-small calendar">
        <i class="material-icons">&#xE916;</i>
      </div>
      <div class="icon is-small chevron-down" v-if="!active">
        <i class="material-icons">&#xE313;</i>
      </div>
      <div class="icon is-small chevron-up" v-else>
        <i class="material-icons">&#xE316;</i>
      </div>
    </div>
    <datepicker
      :value="day"
      :format="customFormatter"
      :disabled="disabled"
      :full-month-name="true"
      :monday-first="true"
      :maximum-view="'day'"
      :language="locale"
      @opened="open"
      @closed="close"
      @selected="selected" />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { parse, format, subWeeks, addDays, subDays, isValid, isAfter } from 'date-fns'
import * as moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import Dropdown from 'views/mixins/dropdown'

export default {

  extends: Dropdown,

  components: {
    Datepicker
  },

  computed: {
    ...mapState('user', [
      'created_at'
    ]),
    ...mapGetters('account', [
      'locale'
    ]),
    day() {
      return parse(this.$store.state.user.day)
    },
    disabled() {
      let to = subWeeks(new Date(), 9)
      const from = addDays(new Date(), 1)
      const createdAt = parse(this.created_at)
      
      if (isValid(createdAt) && isAfter(createdAt, to)) {
        to = subDays(createdAt, 1)
      }

      return {
        to: to,
        from: from
      }
    }
  },

  methods: {
    customFormatter(date) {
      return moment(date).format('D MMM YYYY')
    },

    selected(date) {
      const day = format(date, 'YYYY-MM-DD')
      const query = Object.assign({}, this.$route.query, { day })

      this.$router.push({ query })
    }
  }
}
</script>

<style>
.timeline-datepicker .cell.today {
  background-color: #DDD;
}

</style>

<style lang="scss" scoped>
.timeline-datepicker {
  position: relative;
}

.timeline-datepicker-icons {
  position: absolute;
  z-index: 10;
  pointer-events: none;

  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &.calendar {
      left: .5rem;

      i {
        font-size: .625rem;
      }
    }

    &.chevron-up,
    &.chevron-down {
      right: .375rem;

      i {
        position: relative;
        top: 1px;
        font-size: .875rem;
      }
    }
  }
}
</style>
